import BpkImage, {
  withLazyLoading,
  withLoadingBehavior,
} from '@skyscanner/backpack-web/bpk-component-image';

import { isBrowser } from '@shared/utils-universal/is-browser';

export const documentIfExists = isBrowser() ? window.document : null;

export const FadingLazyLoadedImage = withLoadingBehavior(
  withLazyLoading(BpkImage, documentIfExists),
);
FadingLazyLoadedImage.displayName = 'FadingLazyLoadedImage';

export const LoadingImage = withLoadingBehavior(BpkImage);
LoadingImage.displayName = 'LoadingImage';

export const LazyLoadedImage = withLazyLoading(BpkImage, documentIfExists);
LazyLoadedImage.displayName = 'LazyLoadedImage';
